import React from "react";
import { Card } from "react-bootstrap";
import "./HumanRightsCard.css";

const HumanRightsCard = ({ name, level }) => {
  return (
    <Card className="text-white mb-4 hr-card ">
      <div className="hr-card-header ">
        <div className="hr-card-left text-center">
          <h3 className="hr-card-title">
            {name} {level}
          </h3>
          <p className="hr-card-sub fw-medium">Governing Body</p>
          <p className="hr-card-small">Regd By NITI Aayog, Govt of India</p>
        </div>

        <div className="hr-card-right">
          <img src="/badge.png" alt="Badge" className="hr-badge" />
        </div>
      </div>

      {/* <Card.Body>
        <p className="text-center text-muted mb-0">
          No {level.toLowerCase()} members available.
        </p>
      </Card.Body> */}
    </Card>
  );
};

export default HumanRightsCard;
